import { MaybeConditionalFeature, SubscriptionPlanLimits, SubscriptionPlanName, SubscriptionPlanNameSchema } from '@sona/shared-model-common';
import { checkPermission } from './feature-utils';

export const getLowestPlanForFeature = (plans: SubscriptionPlanLimits[], feature: MaybeConditionalFeature): SubscriptionPlanLimits | undefined => {

    return plans.find((plan) => plan.features && checkPermission(plan.features, feature));
};
export const getLowestPlanForFeatures = (plans: SubscriptionPlanLimits[], features: MaybeConditionalFeature[]): SubscriptionPlanLimits | undefined => {
    return plans.find((plan) => {
        return features.every(feature => plan.features && checkPermission(plan.features, feature));
    });
};

export const getPlansWithFeature = (plans: SubscriptionPlanLimits[], feature: MaybeConditionalFeature): SubscriptionPlanLimits[] => {
    return plans.filter((plan) => plan.features && checkPermission(plan.features, feature));
};

export const isHigherPlan = (planA: SubscriptionPlanName, planB: SubscriptionPlanName): boolean => {
    const indexA = SubscriptionPlanNameSchema.options.indexOf(planA);
    const indexB = SubscriptionPlanNameSchema.options.indexOf(planB);
    return indexA > indexB;
}
